import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const SearchPage = lazy(() => import('../pages/search/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const EulaPage = lazy(() => import('../pages/eula/page'));
const AdobePDFLibraryPage = lazy(() => import('../pages/adobe-pdf-library/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const StatusPage = lazy(() => import('../pages/status/page'));
const SecurityPage = lazy(() => import('../pages/security/page'));
const HelpPage = lazy(() => import('../pages/help/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const LoginPage = lazy(() => import('../pages/login/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const MemberCenterPage = lazy(() => import('../pages/member-center/page'));
const AnnouncementDetailPage = lazy(() => import('../pages/announcement-detail/page'));
const AnnouncementHolidayPage = lazy(() => import('../pages/announcement-holiday/page'));
const AnnouncementServiceBulletinPage = lazy(() => import('../pages/announcement-service-bulletin/page'));
const AdobePDFConverterPage = lazy(() => import('../pages/adobe-pdf-converter/page'));
const PdfRestContainerPage = lazy(() => import('../pages/pdf-rest-container/page'));
const PDFFormsExtensionSDKPage = lazy(() => import('../pages/pdf-forms-extension-sdk/page'));
const PDFFormsFlattenerPage = lazy(() => import('../pages/pdf-forms-flattener/page'));
const PDFOptimizerPage = lazy(() => import('../pages/pdf-optimizer/page'));
const CaseBankDetailPage = lazy(() => import('../pages/case-bank-detail/page'));
const CaseMedicalDetailPage = lazy(() => import('../pages/case-medical-detail/page'));
const CaseEducationDetailPage = lazy(() => import('../pages/case-education-detail/page'));
const BlogDetailPage = lazy(() => import('../pages/blog-detail/page'));
const BlogTimestampSignaturesPage = lazy(() => import('../pages/blog-timestamp-signatures/page'));
const BlogPDFToolsSelectionPage = lazy(() => import('../pages/blog-pdf-tools-selection/page'));
const BlogPDFPerformancePage = lazy(() => import('../pages/blog-pdf-performance/page'));
const BlogCloudArchitecturePage = lazy(() => import('../pages/blog-cloud-architecture/page'));
const BlogFormExtractionPage = lazy(() => import('../pages/blog-form-extraction/page'));
const BlogPDFArchivePage = lazy(() => import('../pages/blog-pdf-archive/page'));
const BlogPDFSecurityPage = lazy(() => import('../pages/blog-pdf-security/page'));
const BlogQRCodeGenerationPage = lazy(() => import('../pages/blog-qr-code-generation/page'));
const BlogFormFieldRecognitionPage = lazy(() => import('../pages/blog-form-field-recognition/page'));
const BlogPdfConverterApplicationPage = lazy(() => import('../pages/blog-pdf-converter-application/page'));
const DocumentWorkflowConsultingPage = lazy(() => import('../pages/document-workflow-consulting/page'));
const BlogContainerDeploymentPage = lazy(() => import('../pages/blog-container-deployment/page'));
const BlogPDFTrends2025Page = lazy(() => import('../pages/blog-pdf-trends-2025/page'));
const BlogAIScrapingPDFsPage = lazy(() => import('../pages/blog-ai-scraping-pdfs/page'));
const BlogAIScrapingPDFs = lazy(() => import('../pages/blog-ai-scraping-pdfs/page'));
const BlogPDFFormsFlattening = lazy(() => import('../pages/blog-pdf-forms-flattening/page'));
const BlogPDFConverterSDK = lazy(() => import('../pages/blog-pdf-converter-sdk/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/member-center',
    element: <MemberCenterPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/search',
    element: <SearchPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/document-workflow-consulting',
    element: <DocumentWorkflowConsultingPage />
  },
  {
    path: '/cases',
    element: <CasesPage />,
  },
  {
    path: '/case-bank-detail',
    element: <CaseBankDetailPage />
  },
  {
    path: '/case-medical-detail',
    element: <CaseMedicalDetailPage />
  },
  {
    path: '/case-education-detail',
    element: <CaseEducationDetailPage />
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/announcement-apdfl-security',
    element: <AnnouncementDetailPage />,
  },
  {
    path: '/announcement-detail',
    element: <AnnouncementDetailPage />,
  },
  {
    path: '/announcement-holiday',
    element: <AnnouncementHolidayPage />,
  },
  {
    path: '/announcement-service-bulletin',
    element: <AnnouncementServiceBulletinPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/eula',
    element: <EulaPage />,
  },
  {
    path: '/adobe-pdf-library',
    element: <AdobePDFLibraryPage />,
  },
  {
    path: '/adobe-pdf-converter',
    element: <AdobePDFConverterPage />
  },
  {
    path: '/pdf-rest-container',
    element: <PdfRestContainerPage />
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/pdf-forms-extension-sdk',
    element: <PDFFormsExtensionSDKPage />
  },
  {
    path: '/pdf-forms-flattener',
    element: <PDFFormsFlattenerPage />
  },
  {
    path: '/pdf-optimizer',
    element: <PDFOptimizerPage />
  },
  {
    path: '/status',
    element: <StatusPage />
  },
  {
    path: '/security',
    element: <SecurityPage />
  },
  {
    path: '/help',
    element: <HelpPage />
  },
  {
    path: '/blog-detail',
    element: <BlogDetailPage />
  },
  {
    path: '/blog-timestamp-signatures',
    element: <BlogTimestampSignaturesPage />
  },
  {
    path: '/blog-pdf-tools-selection',
    element: <BlogPDFToolsSelectionPage />
  },
  {
    path: '/blog-pdf-performance',
    element: <BlogPDFPerformancePage />
  },
  {
    path: '/blog-cloud-architecture',
    element: <BlogCloudArchitecturePage />
  },
  {
    path: '/blog-form-extraction',
    element: <BlogFormExtractionPage />
  },
  {
    path: '/blog-pdf-archive',
    element: <BlogPDFArchivePage />
  },
  {
    path: '/blog-pdf-security',
    element: <BlogPDFSecurityPage />
  },
  {
    path: '/blog-qr-code-generation',
    element: <BlogQRCodeGenerationPage />
  },
  {
    path: '/blog-form-field-recognition',
    element: <BlogFormFieldRecognitionPage />
  },
  {
    path: '/blog-pdf-converter-application',
    element: <BlogPdfConverterApplicationPage />
  },
  {
    path: '/blog-container-deployment',
    element: <BlogContainerDeploymentPage />,
  },
  {
    path: '/blog-pdf-trends-2025',
    element: <BlogPDFTrends2025Page />,
  },
  {
    path: '/blog-ai-scraping-pdfs',
    element: <BlogAIScrapingPDFs />,
  },
  {
    path: '/blog-pdf-forms-flattening',
    element: <BlogPDFFormsFlattening />,
  },
  {
    path: '/blog-pdf-converter-sdk',
    element: <BlogPDFConverterSDK />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
